export function aplicarMascaraTelefone(telefone) {
  telefone = telefone.replace(/\D/g, '');
  if (telefone.length <= 10) {
    // Telefone fixo: (XX) XXXX-XXXX
    telefone = telefone.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
  } else {
    // Celular: (XX) XXXXX-XXXX
    telefone = telefone.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
  }

  return telefone.trim().replace(/(-)$/, '');
}
